import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import stockMessage from "../helpers/stock-message";
import getSellingPlanId from "../helpers/getSellingPlanId";
import CapacityIcon from "./capacityIcon";
import BlendedImage from "./blendedImage";
import { ArrowUpRightBox } from "../helpers/icons";
import SwatchImage from "./swatchImage";
import OptionValuePrice from "./optionValuePrice";

const VariantPickerContent = ({ data, form, group }) => {
  const product = data;
  const variants = data?.variants?.edges;
  const productGroup = group.products;
  const productGroupOptions = group.options;
  const groupStyle = product.tags
    ?.find((t) => t.includes("group:"))
    ?.split(":")[2];

  const colors = product.options.filter((o) => {
    return o.name === "Color";
  })[0];

  const options = product?.options?.filter(
    (option) =>
      option.name != "Color" &&
      option.name != "Default Title" &&
      option.name != "Title",
  );

  // Set Initial Variant Options
  let variantOptions = product?.options.map((edge) => ({
    [edge?.name]: variants[0]?.node?.selectedOptions?.find(
      (element) => element.name == [edge?.name],
    ).value,
  }));

  const [variant, setVariant] = useState(variants[0]);
  const [groupUrl, setGroupurl] = useState(product.handle);
  const [selectedOptions, setSelectedOptions] = useState(variantOptions);

  const handleColorVariants = () => {
    if (!colors) return;
    let so = Object.assign({}, ...selectedOptions);
    let vs = so
      ? variants.filter((v) => {
          let vo = product?.options.map((edge) => ({
            [edge?.name]: v?.node?.selectedOptions.find(
              (element) => element.name == [edge?.name],
            ).value,
          }));
          let voc = Object.assign({}, ...vo);
          return JSON.stringify(voc["Size"]) === JSON.stringify(so["Size"]);
        })
      : variants;
    return vs;
  };

  const [colorVariants, setColorVariants] = useState(handleColorVariants);

  // useEffect(() => {
  //   if (!productGroup) return;
  //   let prices = productGroup.map((item) =>
  //     parseInt(item?.node?.priceRange?.maxVariantPrice?.amount)
  //   );
  //   form.priceRange.innerHTML = `${window.formatMoney(
  //     Math.min(...prices)
  //   )} - ${window.formatMoney(Math.max(...prices))}`;
  // }, [productGroup]);

  useEffect(() => {
    setColorVariants(handleColorVariants());
  }, [selectedOptions]);

  const handleProductInfo = (sv, p) => {
    let cv = sv.node ? sv.node : sv;

    window.handleConfigPricing(cv, form);
    if (groupStyle) {
      let section = document.querySelector("section-product"),
        id = section.getAttribute("id"),
        cb = document.querySelector("[data-related-bundles-container]"),
        cc = document.querySelector("[data-bundle-configuration]"),
        ct = document.querySelector("[data-product-title]"),
        cf = document.querySelector("[data-product-faqs]"),
        cd = document.querySelector("[data-product-description]"),
        cBreadcrumbs = document.querySelector("[data-breadcrumbs]"),
        cSectionData = document.querySelector(
          '[data-section-data="main-product"]',
        ),
        cPrice = document.querySelector("[data-product-price]"),
        cCta = document.querySelector("[data-product-cta]"),
        cPaymentTerms = document.querySelector("shopify-payment-terms"),
        cHighlights = document.querySelector("[data-pdp-highlights]"),
        cSpecs = document.querySelector("[data-pdp-specs]"),
        cUsps = document.querySelector("[data-pdp-usps]"),
        cVideo = document.querySelector("[data-pdp-video]"),
        cSlideshow = document.querySelector("[data-pdp-slideshow]"),
        cFeatures = document.querySelector("[data-pdp-features]");
      fetch(`/products/${p.handle}?section_id=${id}`)
        .then((response) => response.text())
        .then((data) => {
          let parser = new DOMParser(),
            doc = parser.parseFromString(data, "text/html"),
            d = doc.querySelector("[data-product-description]"),
            b = doc.querySelector("[data-related-bundles-container]"),
            c = doc.querySelector("[data-bundle-configuration]"),
            f = doc.querySelector("[data-product-faqs]"),
            t = doc.querySelector("[data-product-title]"),
            breadcrumbs = doc.querySelector("[data-breadcrumbs]"),
            sectionData = doc.querySelector(
              '[data-section-data="main-product"]',
            ),
            price = doc.querySelector("[data-product-price]"),
            cta = doc.querySelector("[data-product-cta]"),
            paymentTerms = doc.querySelector("shopify-payment-terms"),
            highlights = doc.querySelector("[data-pdp-highlights]"),
            specs = doc.querySelector("[data-pdp-specs]"),
            usps = doc.querySelector("[data-pdp-usps]"),
            video = doc.querySelector("[data-pdp-video]"),
            slideshow = doc.querySelector("[data-pdp-slideshow]"),
            features = doc.querySelector("[data-pdp-features]");
          b && (cb.innerHTML = b.innerHTML);
          d && (cd.innerHTML = d.innerHTML);
          d && (cc.innerHTML = c.innerHTML);
          f && (cf.innerHTML = f.innerHTML);
          t && (ct.innerHTML = t.innerHTML);
          breadcrumbs && (cBreadcrumbs.innerHTML = breadcrumbs.innerHTML);
          sectionData && (cSectionData.innerHTML = sectionData.innerHTML);
          cPrice && (cPrice.innerHTML = price.innerHTML);
          cCta && (cCta.innerHTML = cta.innerHTML);
          cPaymentTerms && cPaymentTerms.replaceWith(paymentTerms);
          cHighlights && (cHighlights.innerHTML = highlights.innerHTML);
          cSpecs && (cSpecs.innerHTML = specs.innerHTML);
          cUsps && (cUsps.innerHTML = usps.innerHTML);
          cVideo && (cVideo.innerHTML = video.innerHTML);
          cSlideshow && (cSlideshow.innerHTML = slideshow.innerHTML);
          cFeatures && (cFeatures.innerHTML = features.innerHTML);
          const updateComponents = new CustomEvent("refreshComponents");
          document.dispatchEvent(updateComponents);
        });
    }
  };

  const handleVariantChange = (option, val) => {
    let sv = null,
      svo = null,
      sp = null;
    if (val.node) {
      sp = val.node;
      sv = val.node.variants.edges[0].node;
      svo = val.node.variants.edges[0].node.selectedOptions;
      setGroupurl(val.node.handle);
    } else {
      const selectedOption = selectedOptions.map((o) => {
        if (Object.keys(o) == option) {
          return {
            ...o,
            [option]: val,
          };
        }
        return o;
      });
      const currentOption = {
        [option]: val,
      };

      let vset =
        productGroup && option.toLowerCase() == groupStyle
          ? productGroup
          : variants;

      let selectedVariant = vset.filter((v) => {
        let vo = product?.options.map((edge) => ({
          [edge?.name]: v?.node?.selectedOptions.find(
            (element) => element.name == [edge?.name],
          ).value,
        }));
        return JSON.stringify(vo) === JSON.stringify(selectedOption);
      });

      if (!selectedVariant[0]?.node) {
        selectedVariant = vset.filter((v) => {
          let set = v?.node?.selectedOptions.find(
            (element) => element.name == [option] && element.value == [val],
          );
          return set?.value === currentOption[option];
        });
      }

      sv = selectedVariant.length > 0 ? selectedVariant[0] : selectedVariant;
      svo = sv.node.selectedOptions.map((option) => ({
        [option.name]: option.value,
      }));
      sv = sv.node ? sv.node : sv;

      if (option === "Color") {
        //scroll smoothly to .product-main__media
        const media = document.querySelector(".product-main__media");
        media.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
    setSelectedOptions(svo);
    setVariant(sv);

    if (!groupStyle) {
      form.el.querySelectorAll("[data-product-price]").forEach((el) => {
        el.innerHTML = `
        <span class="price__regular mr-0">${window.formatMoney(
          sv.priceV2.amount,
        )}</span>
        ${
          sv.compareAtPriceV2 &&
          parseFloat(sv.compareAtPriceV2.amount) > parseFloat(sv.priceV2.amount)
            ? `<del class="price__compare">${window.formatMoney(
                sv.compareAtPriceV2.amount,
              )}</del>`
            : ""
        }
        `;
      });
    }

    form.el.querySelectorAll("[data-add-message]").forEach((message) => {
      message.closest("button").disabled = false;

      if (!sv.availableForSale) {
        message.innerHTML = "Out of Stock";
        message.closest("button").disabled = true;
        return;
      }

      message.innerHTML =
        sv.preorder?.value === "true" ? "Pre-Order" : "Add to Cart";
    });

    if (variant === sv) return;
    let currentProduct = sp ? sp : null;
    form.currentProduct = currentProduct;
    form.product = currentProduct;
    const productUpdated = new CustomEvent("productUpdate", {
      detail: {
        ...(currentProduct && { product: currentProduct }),
        variant: sv,
      },
    });
    handleProductInfo(sv, currentProduct);
    document.dispatchEvent(productUpdated);
    updateProperties(sv, val?.node?.handle);
    window.handleConfigPricing(sv, form);
  };

  const updateProperties = (sv, gu) => {
    if (!sv) return;

    let v = sv.node ? sv.node : sv,
      id = v.id.split("/").pop();
    const newUrl = new URL(window.location);
    newUrl.pathname = gu
      ? newUrl.pathname.replace(/\/[^\/]*$/, `/${gu}`)
      : newUrl.pathname;
    newUrl.searchParams.set("variant", id);
    window.history.replaceState({}, "", newUrl);
    const input = form?.el?.querySelector('input[name="id"]');
    input.value = id;
    form.currentVariant = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const handleGroupActive = (name, product) => {
    return product.node.handle == groupUrl;
  };

  const handleVariantActive = (name, val) => {
    let vo = Object.assign({}, ...selectedOptions);
    return vo[name] == val ? "--active" : "";
  };

  const findVariant = (name, value) => {
    const variant = variants
      // Find variants for selected 1st tier
      .filter(({ node }) => {
        const optionsWithMultipleValues = product.options.filter(
          (option) => option.optionValues.length > 1,
        );

        if (optionsWithMultipleValues.length === 1) return true;

        if (
          node.selectedOptions[0].value ===
          selectedOptions[0][node.selectedOptions[0].name]
        )
          return true;

        return false;
      })
      // Find variant for this option value
      .find(({ node }) =>
        node.selectedOptions.some(
          (option) => option.name === name && option.value === value,
        ),
      );

    if (!variant) return null;

    return variant.node;
  };

  const firstButHasOtherOptions = (name) => {
    const optionsWithMultipleValues = product.options.filter(
      (option) => option.optionValues.length > 1,
    );

    return (
      name === product.options[0].name && optionsWithMultipleValues.length > 1
    );
  };

  const findStockMessageFor = (name, value) => {
    // Don't display stock for 1st tier chips unless that is the only tier
    if (firstButHasOtherOptions(name)) {
      return null;
    }

    const variant = findVariant(name, value);

    if (!variant) return null;

    return stockMessage(variant);
  };

  const findVariantFor = (name, value) => {
    // Don't display price for 1st tier chips unless that is the only tier
    if (firstButHasOtherOptions(name)) {
      return null;
    }

    return findVariant(name, value);
  };

  useEffect(() => {
    setTimeout(() => {
      // Preselect variant matching the requested color.
      const { searchParams } = new URL(window.location);
      const param = searchParams.get("color");

      if (!param) return;

      const value = decodeURIComponent(param);
      const name = "Color";

      const matchingOption = product.options.find(
        (option) => option.name === name,
      );

      if (!matchingOption || !matchingOption.values.includes(value)) return;

      handleVariantChange(name, value);
    }, 500);
  }, [product]);

  return (
    <Fragment>
      <input
        type="hidden"
        name="selling_plan"
        value={getSellingPlanId(variant.node || variant)}
      />
      <div className="product-form__variants h5">
        {options?.map((option, index) =>
          option.name.toLowerCase() == groupStyle && productGroupOptions ? (
            <Fragment>
              <div class="product-form__variants__heading__wrapper">
                <div className="product-form__variants__heading h5">
                  Select {groupStyle}
                  <a
                    href="#"
                    class="button-text product-form__help-me-choose-cta"
                    data-modal-trigger="compare-modal"
                  >
                    <span>Help Me Choose</span>
                    <ArrowUpRightBox />
                  </a>
                </div>
              </div>
              <span class="hidden"></span>
              <div
                className={`product-form__options product-form__options--single-column ${groupStyle}`}
              >
                {productGroup?.map((item, i) => (
                  <div className="product-form__option">
                    <input
                      type="radio"
                      id={`template--${option?.name}-${i}`}
                      name={option?.name}
                      value={item.node.title}
                      form={`form-${option.name}`}
                      checked={handleGroupActive(option?.name, item)}
                    />

                    <label
                      for={`template--${option?.name}-${i}`}
                      aria-label={option?.name}
                      className="text product-form__option-label"
                      onClick={() => {
                        handleVariantChange(option?.name, item);
                      }}
                    >
                      <BlendedImage
                        className="product-form__option-variant-image"
                        src={item.node.variants.edges[0].node.image?.src}
                        size="200x"
                      />
                      <div className="product-form__option-text">
                        <span>{item.node.title}</span>

                        {groupStyle != "Size" && (
                          <span
                            class="product-form__option-availability"
                            data-stock
                          >
                            {stockMessage(item.node.variants.edges[0].node)}
                          </span>
                        )}
                        <CapacityIcon
                          className="product-form__option-capacity-icon"
                          node={item.node.variants.edges[0].node}
                        />
                      </div>
                      <OptionValuePrice
                        variant={item.node.variants.edges[0].node}
                        selectedVariant={variant?.node ? variant.node : variant}
                      />
                    </label>
                  </div>
                ))}
              </div>
            </Fragment>
          ) : (
            option.values.length > 1 && (
              <Fragment>
                <div className="product-form__variants__heading h5">
                  Select {option.name}
                </div>
                <span class="hidden"></span>
                <div
                  className={`product-form__options ${option?.name} ${product.options.length <= 1 ? "product-form__options--single-column" : ""}`}
                >
                  {option.values?.map((item, i) => (
                    <Fragment>
                      <div className="product-form__option">
                        <input
                          type="radio"
                          id={`template--${option?.name}-${i}`}
                          name={option?.name}
                          value={item}
                          form={`form-${option.name}`}
                          checked={handleVariantActive(option?.name, item)}
                        />

                        <label
                          for={`template--${option?.name}-${i}`}
                          aria-label="Cruiser 2-Seater"
                          className="text product-form__option-label"
                          onClick={() => {
                            handleVariantChange(option?.name, item);
                          }}
                        >
                          {product.options.length <= 1 && (
                            <BlendedImage
                              className="product-form__option-variant-image"
                              src={
                                findVariantFor(option.name, item)?.image?.src
                              }
                              size="200x"
                            />
                          )}
                          <div className="product-form__option-text">
                            <span>{item}</span>
                            <span
                              class="product-form__option-availability"
                              data-stock
                            >
                              {findStockMessageFor(option.name, item)}
                            </span>
                            {product.options.length <= 1 && (
                              <CapacityIcon
                                className="product-form__option-capacity-icon"
                                node={findVariantFor(option.name, item)}
                              />
                            )}
                          </div>
                          <OptionValuePrice
                            variant={findVariantFor(option.name, item)}
                            selectedVariant={
                              variant?.node ? variant.node : variant
                            }
                          />
                        </label>
                      </div>
                    </Fragment>
                  ))}
                </div>
              </Fragment>
            )
          ),
        )}
        {colorVariants?.length > 1 && (
          <Fragment>
            <div className="product-form__variants__heading h5">
              Select {colors.name}
            </div>
            <span class="hidden"></span>
            <div className={`product-form__options ${colors?.name}`}>
              {colorVariants?.map((item, i) => (
                <Fragment>
                  <div className="product-form__option">
                    <input
                      type="radio"
                      id={`template--${colors?.name}-${i}`}
                      name={colors?.name}
                      value={item.node.title.split(" / ").pop()}
                      form={`form-${colors.name}`}
                      checked={handleVariantActive(
                        "Color",
                        item.node.title.split(" / ").pop(),
                      )}
                    />

                    <label
                      for={`template--${colors?.name}-${i}`}
                      aria-label="Cruiser 2-Seater"
                      className="text product-form__option-label--color"
                      onClick={() => {
                        handleVariantChange(
                          "Color",
                          item.node.title.split(" / ").pop(),
                        );
                      }}
                    >
                      <SwatchImage
                        product={product}
                        handle={product?.handle}
                        optionValue={item?.node?.title.split(" / ").pop()}
                        className="product-form__option-swatch"
                      />
                      <div className="product-form__option-text">
                        <span>{item.node.title.split(" / ").pop()}</span>
                        <span
                          class="product-form__option-availability"
                          data-stock
                        >
                          {stockMessage(item.node)}
                        </span>
                      </div>
                      <OptionValuePrice
                        variant={item.node}
                        selectedVariant={variant?.node ? variant.node : variant}
                      />
                    </label>
                  </div>
                </Fragment>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default VariantPickerContent;
